import React from 'react'
import { UnauthorizedCard } from 'src/components/UnauthorizedCard'
import { Grid } from '@softwaredev_cegeka/stix-core'
import { Header } from 'src/components'

export default function Unauthorized() {
    // keep this outside of the main routes so we don't loop indefinitely
    // when the user is unauthorized
    return (
        <>
            <Header stripped />
            <Grid.Container className={'error-page'}>
                <UnauthorizedCard />
            </Grid.Container>
        </>
    )
}
